import { useState } from "react";
import { GripVertical, Star, X } from "lucide-react";
import { imageUrl } from "@/lib/api";

export const PhotoReorder = ({ images, onChange, onRemove, testidPrefix = "photo" }) => {
  const [dragIndex, setDragIndex] = useState(null);
  const [overIndex, setOverIndex] = useState(null);

  const move = (from, to) => {
    if (from === to || from == null || to == null) return;
    const next = [...images];
    next.splice(to, 0, next.splice(from, 1)[0]);
    onChange(next);
  };

  if (!images.length) return null;

  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid={`${testidPrefix}-reorder-grid`}>
        {images.map((id, i) => (
          <div
            key={id}
            draggable
            onDragStart={() => setDragIndex(i)}
            onDragEnter={() => setOverIndex(i)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => {
              move(dragIndex, i);
              setDragIndex(null);
              setOverIndex(null);
            }}
            onDragEnd={() => {
              setDragIndex(null);
              setOverIndex(null);
            }}
            className={`group relative aspect-square cursor-grab overflow-hidden rounded-xl border-2 transition-colors duration-150 ${
              overIndex === i && dragIndex !== i ? "border-primary" : "border-transparent"
            } ${dragIndex === i ? "opacity-40" : ""}`}
            data-testid={`${testidPrefix}-tile-${i}`}
          >
            <img src={imageUrl(id)} alt={`Photo ${i + 1}`} className="h-full w-full object-cover" draggable={false} />

            {i === 0 && (
              <span className="absolute left-2 top-2 flex items-center gap-1 rounded-full bg-background px-2.5 py-1 text-[10px] font-bold shadow-search">
                <Star className="h-3 w-3 fill-foreground" /> Cover
              </span>
            )}

            <span className="absolute bottom-2 left-2 rounded-full bg-background/90 p-1.5 shadow-search">
              <GripVertical className="h-3.5 w-3.5" />
            </span>

            <div className="absolute bottom-2 right-2 flex gap-1">
              <button
                type="button"
                onClick={() => move(i, i - 1)}
                disabled={i === 0}
                className="rounded-full bg-background/90 px-2 py-1 text-[11px] font-bold shadow-search disabled:opacity-40"
                data-testid={`${testidPrefix}-move-up-${i}`}
                aria-label="Move earlier"
              >
                ←
              </button>
              <button
                type="button"
                onClick={() => move(i, i + 1)}
                disabled={i === images.length - 1}
                className="rounded-full bg-background/90 px-2 py-1 text-[11px] font-bold shadow-search disabled:opacity-40"
                data-testid={`${testidPrefix}-move-down-${i}`}
                aria-label="Move later"
              >
                →
              </button>
            </div>

            {onRemove && (
              <button
                type="button"
                onClick={() => onRemove(id)}
                className="absolute right-2 top-2 rounded-full bg-background p-1.5 shadow-search"
                data-testid={`${testidPrefix}-remove-${i}`}
                aria-label="Remove photo"
              >
                <X className="h-3 w-3" />
              </button>
            )}
          </div>
        ))}
      </div>
      <p className="mt-2 text-[11px] text-muted-foreground">
        Drag a photo (or use ← →) to reorder. The first photo is the cover buyers see.
      </p>
    </div>
  );
};

export default PhotoReorder;
